import React, { useState, useCallback, useEffect } from "react";
import { Row } from "react-bootstrap";
import { Card } from "react-bootstrap";
import IDSTable from "./IDSTable";
import Alert from "react-bootstrap/Alert";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { ERROR_MSG } from "../services/Constants";
import { reportingLoincsHeadCells } from "../util/headcells-util";
import ReportingLOINCAddUpdateModal from "./ReportingLOINCAddUpdateModal";
import {
  fetchReportingLoincDatabyLoincId,
  removeReportingLoincRecord,
} from "../services/reportingLoinc-service";
import { getAllPerformingFacilities } from "../services/performingFacilities-service";


const LOINCFormReportingLoincsCard = (props) => {
  const { childFormRef, loincId } = props;
  const [showRemoveWarningModal, setShowRemoveWarningModal] = useState(false);

  const [selectedRow, setSelectedRow] = useState([]);
  const [recordsPerPage, setRecordsPerPage] = useState(5);
  const [pageNo, setPageNo] = useState(0);
  const [isAdded, setIsAdded] = useState(false);
  const [modifiedRow, setModifiedRow] = useState(null);
  const [alertMessage, setAlertMessage] = useState();
  const [isAddNew, setIsAddNew] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isFetchError, setIsFetchError] = useState(false);
  const [reportingLoincData, setReportingLoincData] = useState(null);
  const [reportingLoincTotalPages, setReportingLoincTotalPages] =
    useState(null);
  const [showAddUpdateModal, setShowAddUpdateModal] = useState(false);
  const [performingFacilityData, setPerformingFacilityData] = useState([]);
  const handleClose = () => {
    setShowAddUpdateModal(false);
  };
  const handleRemoveWarningModalClose = () => setShowRemoveWarningModal(false);

  const getReportingLoincData = useCallback(async () => {
    let response = await fetchReportingLoincDatabyLoincId(
      loincId,
      pageNo,
      recordsPerPage
    );
    if (response.ok) {
      let data = await response.json();
      if (data.genericList != null) {
        const reportingLoincCodesTableData = data.genericList.map((item) => ({
          reportingLoincId: item.reportingLoincId,
          reportingLoincCode: item?.reportingLoincCode,
          performingFacilityName:
            item?.performingFacility?.performingFacilityName,
        }));
        setReportingLoincData(reportingLoincCodesTableData);
        setReportingLoincTotalPages(data.totalPages);
      } else {
        setIsFetchError(true);
        let error = await response.json();
        setIsError(true);
        setAlertMessage(error?.description);
      }
    } else {
      let error = await response.json();
      setIsFetchError(true);
      setIsError(true);
      setAlertMessage(error?.description);
    }
  }, [pageNo, recordsPerPage]);

  const getPerformingFacilities = async () => {
    let response = await getAllPerformingFacilities();
    if (response.ok) {
      let data = await response.json();
      setPerformingFacilityData(data);
    }
  };

  const setSelectedRemoveRowCallback = (rows) => {
    setSelectedRow(rows);
    setShowRemoveWarningModal(true);
  };

  const setSelectedRowCallback = (rows) => {
    setSelectedRow(rows);
  };

  const setRecordsPerPageCallback = (value) => {
    setRecordsPerPage(value);
  };

  const setPageNoCallback = (value) => {
    setPageNo(value);
  };

  useEffect(() => {
    getReportingLoincData();
  }, [pageNo, recordsPerPage, getReportingLoincData]);

  useEffect(() => {
    if (isAdded) {
      getReportingLoincData();
    }
  }, [isAdded, getReportingLoincData]);

  useEffect(() => {
    getPerformingFacilities();
  }, []);
  
  useEffect(() => {
    if (pageNo >= reportingLoincData?.totalPages) {
      reportingLoincData?.totalPages !== 0 && setPageNo(reportingLoincData?.totalPages - 1);
    }
  }, [reportingLoincData]);

  const handleAddReportingLoinc = () => {
    setIsAddNew(true);
    setShowAddUpdateModal(true);
    setIsAdded(false);
    setIsError(false);
  };
  const removeReportingLoinc = async () => {
    let response = await removeReportingLoincRecord(
      selectedRow.reportingLoincId
    );
    if (response !== ERROR_MSG) {
      // setIsDeleted(true);
      setSelectedRemoveRowCallback(null);
    } else {
      setIsError(true);
    }
    handleRemoveWarningModalClose();
  };
  const buttonsLayout = () => {
    return <div></div>;
  };

  const renderBannerMessage = () => {
    if (isAdded) {
      return (
        "New Reporting LOINC code : " +
        modifiedRow +
        " has been successfully added!"
      );
    } else if (isError) {
      return alertMessage
        ? alertMessage
        : "Something went wrong, please try again";
    }
  };

  return (
    <>
      <Card className="card" style={{ marginTop: "40px" }}>
        <Row style={{ padding: "40px 40px 40px 40px" }}>
          <div className="cardBody">Reporting LOINCS</div>
        </Row>
        {(isAdded || isError) && (
          <Row style={{ marginLeft: "40px", marginRight: "150px" }}>
            <Alert
              key={"success"}
              variant={isError ? "danger" : "success"}
              onClose={() => {
                setIsAdded(false);
                setIsError(false);
              }}
              dismissible
            >
              {renderBannerMessage()}
            </Alert>
          </Row>
        )}
        <Row style={{ padding: "0px 40px 40px 40px" }}>
          <IDSTable
            hasDeleteRowOption={true}
            // isErrorScreen={true}
            isFetchError={isFetchError}
            setPageNoCallback={setPageNoCallback}
            setRecordsPerPageCallback={setRecordsPerPageCallback}
            setSelectedRemoveRowCallback={setSelectedRemoveRowCallback}
            setSelectedRowCallback={setSelectedRowCallback}
            headCells={reportingLoincsHeadCells}
            rows={reportingLoincData}
            pages={reportingLoincTotalPages}
            buttonsLayout={buttonsLayout}
            addButtonName="Add new Reporting LOINC"
            addButtonAction={handleAddReportingLoinc}
            isReportingLoincTable={true}
          />
        </Row>
      </Card>
      <ReportingLOINCAddUpdateModal
        loincId={loincId}
        show={showAddUpdateModal}
        handleClose={handleClose}
        setIsAdded={setIsAdded}
        setIsError={setIsError}
        isAddNew={isAddNew}
        setModifiedRow={setModifiedRow}
        childFormRef={childFormRef}
        performingFacilityData={performingFacilityData}
      />
      <Modal
        show={showRemoveWarningModal}
        onHide={handleRemoveWarningModalClose}
        size="lg"
        centered
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Remove Reporting LOINC Code
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <React.Fragment>
            <Form.Label className="modalLabel generalFont">
              Are you sure you want to remove this Reporting LOINC Code from the
              Table?
            </Form.Label>
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer className="modalFooterContainer">
          <Button
            onClick={handleRemoveWarningModalClose}
            className="modalCancelStyle generalFont flexCenter"
            variant="secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={removeReportingLoinc}
            className="modalRemoveStyle generalFont flexCenter"
          >
            Remove
          </Button>
        </Modal.Footer>
      </Modal>{" "}
    </>
  );
};

export default LOINCFormReportingLoincsCard;
